export default __webpack_public_path__ + "static/media/logo.afeb2b1e.png";